// 常见问题
<template>
  <div class="cjwt width1200" role="tablist">
<!--    <div class="item">
      <p class="title">动态HTTP代理隧道常见问题</p>
      <div class="item-list">
        <div class="collapse-ans">
          本页面提供关于动态HTTP代理隧道的一些常见问题的解答，如果您在使用过程中遇到问题，可以参阅。此外，您也可以在相关技术支持群里寻求帮助。
        </div>
      </div>
    </div>-->
    <div class="item" v-for="(item, index) in cjwtList" :key="index">
      <p class="title">{{ item.title }}</p>
      <div class="item-list">
        <div
          v-for="(accordion, accordionIndex) in item.data"
          :key="accordionIndex"
        >
          <div
            class="collapse-title d-flex d-flex-aic d-flex-jc-sb"
            :class="tabs == `${index}-${accordionIndex}` ? 'active' : ''"
            @click="collapseChange(index, accordionIndex)"
          >
            <span>{{ accordion.req }}</span>
            <img
              :src="
                require(tabs == `${index}-${accordionIndex}`
                  ? '@/assets/images/icon12.png'
                  : '@/assets/images/icon11.png')
              "
              alt=""
            />
          </div>
          <div
            class="collapse-ans"
            :style="{
              display: tabs == `${index}-${accordionIndex}` ? 'block' : 'none',
            }"
          >
            {{ accordion.ans }}
            <!--{{ (tabs, `${index}-${accordionIndex}`) }}-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabs: "0-0",
      cjwtList: [
        {
          title: "功能相关问题",
          data: [
            {
              req: "1.IP能使用多久？",
              ans: "长效代理指的是线路是长效的，IP受运营商策略的控制在1-3天会切换。实际使用过程中提取到的线路IP已经存活了一段时间",
            },
            {
              req: "2.购买的是否有数量要求？",
              ans: "购买或者升级都是20条起",
            },
            {
              req: "3.单个代理是否有并发限制",
              ans: "没有，但是实际使用会受到网络、边缘设备负载等外部因素影响没有一个具体的数值",
            },
            {
              req: "4.每次最多能提取多少IP？",
              ans: "根据实际购买的线路数，每条线路对应一个IP",
            },
          ],
        },
        // {
        //   title: "IP池相关问题",
        //   data: [
        //     {
        //       req: "池子里的代理IP都是在网上采集的免费代理吗？",
        //       ans: "1",
        //     },
        //     {
        //       req: "总池子多少IP？",
        //       ans: "1",
        //     },
        //     {
        //       req: "地区分布如何？",
        //       ans: "1",
        //     },
        //   ],
        // },
        // {
        //   title: "购买相关问题",
        //   data: [
        //     {
        //       req: "带宽或者每秒请求数能够在默认套餐基础上额外增加吗？",
        //       ans: "1",
        //     },
        //     {
        //       req: "可以免费测试吗？",
        //       ans: "2",
        //     },
        //     {
        //       req: "是否可以开具发票？",
        //       ans: "3",
        //     },
        //     {
        //       req: "是否可以签订合同？",
        //       ans: "4",
        //     },
        //   ],
        // },
      ],
    };
  },
  methods: {
    collapseChange(index, accordionIndex) {
      this.tabs = `${index}-${accordionIndex}`;
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/cjwt.less";
</style>
